export default (eventHub, { enabled }, store) => {
  if (enabled && typeof window !== 'undefined' && window._learnq && window._learnq instanceof Array) {
    eventHub.$on('eventReport', async({ event, ecommerce, ...data }) => {
      const endpoint = window.location.origin

      const getImageUrl = async(image) => {
        if (!image || !image.filepath || !image.filestorename) return ''

        let url = ''

        let preset = image.preset || '__original'
        let imgSpec = {
          ...image,
          preset
        }

        url = store.getters['filestore/fileCachedImageURL'](imgSpec)
        if (url) return url
        return store.dispatch('filestore/getFileURL', imgSpec)
      }

      if (event === 'view_wine') {
        window._learnq.push(['track', 'Viewed Product', {
          'Product ID': ecommerce.item_id,
          'SKU': ecommerce.sku,
          'Product Name': ecommerce.item_name,
          'Item Price': ecommerce.price,
          'Product Type': ecommerce.product_type,
          'Varietal': ecommerce.wine_varietal,
          'Sweetness': ecommerce.sweetness,
          'Wine Type': ecommerce.wine_type,
          'Series': ecommerce.wine_series,
          'Bottle Size': ecommerce.bottle_size,
          'Vintage': ecommerce.vintage,
          'Wine Body': ecommerce.wine_body,
          'Product Link URL by id': `${endpoint}/node/${ecommerce.item_id}`,
          'Product Link URL by path': `${endpoint}${ecommerce.path}`,
          'Product Image URL': await getImageUrl(ecommerce.image)
        }])
      }

      if (event === 'add_to_cart') {
        const items = []
        for (const item of Object.values(ecommerce.items)) {
          const baseItem = store.getters['products/findProductByID'](item.item_id ?? item.nid)
          items.push({
            'Product ID': baseItem.nid,
            'SKU': baseItem.sku,
            'Product Name': baseItem.title,
            'Item Price': item.price,
            'Product Type': baseItem.product_type,
            'Varietal': baseItem.varietal,
            'Sweetness': baseItem.sweetness,
            'Wine Type': baseItem.wine_type,
            'Series': baseItem.series,
            'Bottle Size': baseItem.bottle_size,
            'Vintage': baseItem.vintage,
            'Wine Body': baseItem.wine_body,
            'Quantity': item.qty,
            'Row Total': item.price * item.qty,
            'Product Link URL by id': `${endpoint}/node/${baseItem.nid}`,
            'Product Link URL by path': `${endpoint}${baseItem.path}`,
            'Product Image URL': await getImageUrl(baseItem.image)
          })
        }

        window._learnq.push(['track', 'Added to Cart', {
          '$value': ecommerce.total_value,
          'Added Product ID': ecommerce.item_id,
          'Added SKU': ecommerce.sku,
          'Added Product Name': ecommerce.item_name,
          'Added Item Price': ecommerce.price,
          'Added Product Type': ecommerce.product_type,
          'Added Varietal': ecommerce.wine_varietal,
          'Added Sweetness': ecommerce.sweetness,
          'Added Wine Type': ecommerce.wine_type,
          'Added Series': ecommerce.wine_series,
          'Added Bottle Size': ecommerce.bottle_size,
          'Added Vintage': ecommerce.vintage,
          'Added Wine Body': ecommerce.wine_body,
          'Added Quantity': ecommerce.qty,
          'Added UUID': ecommerce.uuid,
          'Added Row Total': ecommerce.row_total,
          'Items': items
        }])
      }

      if (event === 'checkout_options') {
        const items = []
        const itemNames = []
        for (const item of Object.values(ecommerce.items)) {
          const baseItem = store.getters['products/findProductByID'](item.item_id ?? item.nid)
          itemNames.push(baseItem.title)
          items.push({
            'Product ID': baseItem.nid,
            'SKU': baseItem.sku,
            'Product Name': baseItem.title,
            'Item Price': item.price,
            'Product Type': baseItem.product_type,
            'Varietal': baseItem.varietal,
            'Sweetness': baseItem.sweetness,
            'Wine Type': baseItem.wine_type,
            'Series': baseItem.series,
            'Bottle Size': baseItem.bottle_size,
            'Vintage': baseItem.vintage,
            'Wine Body': baseItem.wine_body,
            'Quantity': item.qty,
            'Row Total': item.price * item.qty,
            'Product Link URL by id': `${endpoint}/node/${item.item_id}`,
            'Product Link URL by path': `${endpoint}${item.path}`,
            'Product Image URL': await getImageUrl(item.image)
          })
        }

        window._learnq.push(['track', 'Started Checkout', {
          '$value': ecommerce.total,
          'ItemNames': itemNames,
          'CheckoutURL': window.location.href,
          'Items': items
        }])
      }
    })
  }
}
